import { DDSDisplayText } from "@web-monorepo/dds";
import { getImageSrc } from "@web-monorepo/static-assets";
import { useEffect } from "react";
import { Textfit } from "react-textfit";
import logEvent from "src/utils/logEvent";
import styles from "./TodayResult.module.css";

const sunSvg = getImageSrc("toolkit/src/pods/today/assets/sun.svg");

type Props = {
  title?: string;
  text?: string;
};

export default function TodayResult({ title, text }: Props) {
  useEffect(() => {
    logEvent({ eventName: "morning.result.open" });
    return () => {
      logEvent({ eventName: "morning.result.close" });
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={sunSvg} className={styles.sun} alt="" />
        {title && (
          <DDSDisplayText as="h1" level="md" className={styles.title}>
            {title}
          </DDSDisplayText>
        )}
        <Textfit min={32} className={styles.textfit}>
          {text}
        </Textfit>
      </div>
    </div>
  );
}
